module.exports = __webpack_public_path__ + "static/media/autokar3 (12).1234c263.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar3 (12).jpg
// module id = 858
// module chunks = 0